"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIRequesterSettings = exports.APIRequester = void 0;
const axios_1 = require("axios");
const Baaanggg_1 = require("./Baaanggg");
class APIRequester {
    constructor(baseURL, settings) {
        this.settings = settings;
        this._axios = axios_1.default.create({
            baseURL: baseURL,
        });
        this._axios.interceptors.request.use(config => {
            const token = settings.getToken();
            if (token)
                config.headers.Authorization = "Bearer " + token.accessToken;
            return config;
        }, error => Promise.reject(error));
        this._axios.interceptors.response.use(res => res, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const request = error.config;
            const authPaths = [
                '/auth/sign-in',
                '/auth/refresh',
                '/auth/sign-in/admin'
            ];
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !request._retry && !authPaths.includes(error.config.url)) {
                request._retry = true;
                const token = settings.getToken();
                if (token) {
                    let newToken = undefined;
                    for (let i = 0; i < 3; i++) {
                        try {
                            newToken = yield this.refreshToken(token);
                            if (newToken)
                                break;
                        }
                        catch (_b) { }
                    }
                    if (newToken) {
                        settings.onAuthenticated(newToken);
                        return this._axios(request);
                    }
                    else {
                        try {
                            yield this.settings.requestAuthCallback();
                            return yield this._axios(request);
                        }
                        catch (_c) { }
                    }
                }
                else {
                    try {
                        yield this.settings.requestAuthCallback();
                        return yield this._axios(request);
                    }
                    catch (_d) { }
                }
            }
            return Promise.reject(error);
        }));
    }
    refreshToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.post('/auth/refresh', {
                    refreshToken: token.refreshToken,
                });
                return response;
            }
            catch (error) {
                return undefined;
            }
        });
    }
    ;
    post(endpoint, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.post(endpoint, data, config);
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    postForm(endpoint, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.postForm(endpoint, data);
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    put(endpoint, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.put(endpoint, data);
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    putForm(endpoint, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.putForm(endpoint, data);
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    delete(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.delete(endpoint);
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    get(endpoint, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._axios.get(endpoint, { params: params });
                return res.data;
            }
            catch (e) {
                throw this.handleError(e);
            }
        });
    }
    handleError(e) {
        var _a;
        if ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data)
            throw new Baaanggg_1.ApiError(e.response.data);
    }
}
exports.APIRequester = APIRequester;
class APIRequesterSettings {
}
exports.APIRequesterSettings = APIRequesterSettings;
